exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-upload[data-v-1c86fe1c] {\n  margin-bottom: 10px;\n}\n.image-upload[data-v-1c86fe1c]:nth-last-child(1) {\n  margin-bottom: 0;\n}\n.login-btn[data-v-1c86fe1c] {\n  width: 200px;\n  height: 40px;\n  background: #1f8df2;\n  border-radius: 20px;\n  border: none;\n  margin-top: 20px;\n}\n", ""]);

// exports
